import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({
    providedIn: 'root'
})

export class LoaderService {
    isLoading$ = new BehaviorSubject(false);
    reqCount: number = 0;
    progressPercent$ = new BehaviorSubject<null | number>(null);

    show(){
        this.reqCount++;

        this.isLoading$.next(true);
    }

    hide(){
        this.reqCount--;
        if(this.reqCount === 0){
            this.isLoading$.next(false);
        }
    }

    updateProgressCount(val: number) {
        this.progressPercent$.next(val);
    }
    
    resetProgress() {
        this.progressPercent$.next(null);
    }
}